const doc = [({"en":({"js":({"admin":({"contacts":({"show":({"school_information_card":({"school_information":"School information"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;